import { useState, useEffect } from "react";
import { deduplicateNotes, sortNotesByDate } from "../utils/noteUtils";

export const useNotesData = ({
  searchTerm,
  hasActiveFilters,
  searchResults,
  filteredNotesFromApi,
  localNotes,
  finalDisplayNotes,
  manuallyUpdatedPriorities = {},
}) => {
  const [displayNotes, setDisplayNotes] = useState([]);

  useEffect(() => {
    let notes = [];

    if (searchTerm.trim() || hasActiveFilters) {
      // Search or filter mode - use the filtered/search results
      const sourceNotes = searchTerm.trim()
        ? searchResults || []
        : filteredNotesFromApi || [];
      
      notes = deduplicateNotes(sourceNotes);
    } else {
      // Normal view - use localNotes (which is synced with finalDisplayNotes)
      notes = localNotes || [];
    }

    // Apply manually updated priorities
    if (manuallyUpdatedPriorities && Object.keys(manuallyUpdatedPriorities).length > 0) {
      notes = notes.map(note => ({
        ...note,
        priority: manuallyUpdatedPriorities[note.id] !== undefined
          ? manuallyUpdatedPriorities[note.id]
          : note.priority
      }));
    }

    // Sort by date (most recent first)
    setDisplayNotes(sortNotesByDate(notes));
  }, [
    searchTerm,
    hasActiveFilters,
    searchResults,
    filteredNotesFromApi,
    localNotes,
    manuallyUpdatedPriorities,
  ]);

  return { displayNotes };
};